import React, { useEffect, useMemo, useState } from 'react';

import { Grid, TextField } from '@material-ui/core';
import { useSelector } from 'react-redux';
import helpers from 'app/utils/helpers';
import companyEndpoints from 'app/api/services/companyEndpoints';

function TypeSelector(props) {
  const service = useSelector(state => state.services.details);
  const request = useSelector(state => state.requests.details);
  const activeCompany = useSelector(state => state.company.activeCompany);
  const user = useSelector(state => state.auth.user);
  const registrationUserInfo = useSelector(state => state.auth.registrationInfo);
  const userAdmin = useSelector(state => state.auth.userAdmin);
  const internalNewRequest = useSelector(state => state.forms.internalNewRequest);

  const [nmCompany, setNmCompany] = useState('');
  const [deCpfCnpj, setDeCpfCnpj] = useState('');
  const [nuAgerba, setNuAgerba] = useState('');
  const [nuEmbratur, setNuEmbratur] = useState('');
  const [companyData, setCompanyData] = useState({});

  useEffect(() => {
    const init = async () => {

      if (!request.cdSolicitacao) {
        if(internalNewRequest && internalNewRequest.company){
          setCompanyData(internalNewRequest.company);
        } else if (activeCompany && Object.keys(activeCompany).length > 0) {
          setCompanyData(activeCompany);
        } else if (user.cdUsuarioAdmin) {
          setCompanyData(userAdmin);
        } else if (registrationUserInfo && Object.keys(registrationUserInfo).length > 0) {
          setCompanyData(registrationUserInfo);
        }
      } else {
        if (request.cdEmpresa) {
          const response = await companyEndpoints.getCompany({ cdEmpresa: request.cdEmpresa });
          if (response.status === 200 && response.data) {
            setCompanyData(response.data);
            return;
          }
        }else{
          const json = JSON.parse(request.jsonSolicitacao);
          setCompanyData(json);
        }
      }
    };
    init();
  }, [activeCompany, internalNewRequest, registrationUserInfo, request, user.cdUsuarioAdmin, userAdmin]);

  const tpLicense = useMemo(() => {
    if (service.nmServico) {
      return service.nmServico;
    }
    return '';
  }, [service.nmServico]);

  useEffect(() => {
    if (Object.keys(companyData).length > 0) {
      const name = companyData.deRazaoSocial || companyData.nmCompleto || companyData.nmUsuario;
      const doc = companyData.deCnpjMatriz || companyData.deCpf || companyData.deCpfCnpj;
      if (doc) {
        setDeCpfCnpj(helpers.formatarDocumento(doc));
      }
      if (name) {
        setNmCompany(name);
      }
      if (companyData.cdEmpresa) {
        setNuAgerba(companyData.cdEmpresa);
      }
      if (companyData.nuEmbratur) {
        setNuEmbratur(companyData.nuEmbratur);
      }
    }
  }, [companyData]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          name=""
          label="Tipo de licença"
          margin="dense"
          variant="filled"
          fullWidth
          disabled
          value={tpLicense}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}></Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name=""
          label="Nome / Razão Social"
          margin="dense"
          variant="filled"
          fullWidth
          disabled
          value={nmCompany}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name=""
          label="CNPJ / CPF"
          margin="dense"
          variant="filled"
          fullWidth
          disabled
          value={deCpfCnpj}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name=""
          label="Código cadastro na AGERBA"
          margin="dense"
          variant="filled"
          fullWidth
          disabled
          value={nuAgerba}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name=""
          label="Número na EMBRATUR"
          margin="dense"
          variant="filled"
          fullWidth
          disabled
          value={nuEmbratur}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
    </Grid>
  );
}

export default TypeSelector;
